import { useProfileContext } from "@/providers/profile-provider/profile-provider";
import { useEffect, useState } from "react";
import { trialDatasetMinutesLength } from "@/services/license/license-limiters/dataset-duration-limiters/custom-voice-dataset-duration-limiter";
import { customVoiceLicenseManager } from "@/services/license/license-managers/custom-voices-license-manager";
import { LicenseName } from "@/data/license.data";

export const useCustomLimitations = () => {
  const {
    user,
    license,
    isLoading: isProfileLoading,
    isLicenseFetched,
  } = useProfileContext();
  const [durationMax, setDurationMax] = useState<number>();
  const [isCustomLimitationLoading, setIsCustomLimitationLoading] =
    useState(true);

  const isLoading = isProfileLoading || isCustomLimitationLoading;

  useEffect(() => {
    const fetchUserCustomDatasetLimitations = async (
      userId: string | undefined,
      license: LicenseName,
    ) => {
      if (userId) {
        try {
          setIsCustomLimitationLoading(true);
          const datasetLimitDuration =
            await customVoiceLicenseManager.datasetDurationLimiter.getLimit(
              userId,
              license,
            );
          setDurationMax(datasetLimitDuration);
        } catch (error) {
          console.error("Failed to fetch license limitation:", error);
        } finally {
          setIsCustomLimitationLoading(false);
        }
      } else {
        setDurationMax(trialDatasetMinutesLength);
        setIsCustomLimitationLoading(false);
      }
    };

    if (isLicenseFetched) {
      fetchUserCustomDatasetLimitations(user?.id, license);
    }
  }, [isLicenseFetched, license, user?.id]);

  return {
    isLoading,
    license,
    durationMax,
  };
};
